import React, { forwardRef, Ref } from 'react';

import { StyledTextArea } from './TextArea.styles';

import { TextAreaProps } from './TextArea.types';

const TextArea = forwardRef(
  (
    {
      name,
      placeholder = '',
      value = null,
      hasError = false,
      isDisabled = false,
      isRequired = false,
      maxLength,
      componentClassname = 'text-area',
      customClassnames = '',
      customStyle = '',
      ...props
    }: TextAreaProps,
    ref: Ref<HTMLTextAreaElement>,
  ) => {
    return (
      <StyledTextArea
        name={name}
        placeholder={placeholder}
        className={`${componentClassname} ${
          hasError ? `${componentClassname}--has-error` : ''
        } ${customClassnames}`}
        customStyle={customStyle}
        disabled={isDisabled}
        required={isRequired}
        maxLength={maxLength}
        value={value}
        {...props}
        ref={ref}
      />
    );
  },
);
TextArea.displayName = 'TextArea';

export default TextArea;
